<template>
    <div id='page-table'>
        <div id=home-main>
            <div id="main-header">
              <div @click="beforePage" class="bakc-next" style="border-right: 1px solid #bbbbbb;">
                <font-awesome-icon icon="backward" />
              </div>
              <div id="header-title" class="hand-pointer">
                <div @click="activePage" :id="Page" :class="Page == $store.getters.nowPageValue ? 'other-page other-page-active' : 'other-page'" v-for="(Page, i) in $store.getters.pageNames" v-bind:key="Page">
                  <div class="other-page-name">{{$store.getters.menuMapping[Page]}}</div>
                  <i @click.stop="closePage" class="el-icon-close page-close-icon" v-show="Page == $store.getters.nowPageValue &&  $store.getters.nowPageValue != 'Home'" :id="i"></i>
                </div>
              </div>
              <div @click="nextPage" class="bakc-next"  style="border-left: 1px solid #bbbbbb;">
                <font-awesome-icon icon="backward" rotation="180" />
              </div>
              <div class="bakc-next"  style="border-left: 1px solid #bbbbbb;">
                
                <el-dropdown trigger="click">      
                  <span class="el-dropdown-link">
                    <font-awesome-icon class="bakc-next" icon="sort-down" />
                  </span>            
                  <el-dropdown-menu slot="dropdown">
                    <div @click="activePage" :id="Page" v-for="(Page, i) in $store.getters.pageNames" v-bind:key="Page"><el-dropdown-item >{{$store.getters.menuMapping[Page]}}</el-dropdown-item></div>
                    <div @click="dialogVisible = true"><el-dropdown-item divided :disabled="$store.getters.pageNames.length<=1">关闭所有</el-dropdown-item></div>
                  </el-dropdown-menu>
                </el-dropdown>
                
              </div>
              <div id="help-ico" class="hand-pointer" style="border-left: 1px solid #bbbbbb;">
                <font-awesome-icon icon="question-circle" />
              </div>
            </div>
            <div id="main-content">
              <div id="menu-on-off">
                <img class="showmenu-button" @click="showMenu" v-if="$store.getters.menuType" src="../assets/img/left.png"/>
                <img class="showmenu-button" @click="showMenu" v-if="!$store.getters.menuType" src="../assets/img/right.png"/>
              </div>
              <div class="content-one" ref="content-one">
                  <keep-alive>                  
                    <component :is="$store.getters.nowPageValue" :include="$store.getters.pageNames"></component>
                  </keep-alive>              
              </div>
              <el-backtop target=".content-one"></el-backtop>
            </div>
          </div>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
          <span>确认关闭所有吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="closePageAll">确 定</el-button>
          </span>
        </el-dialog>
    
    </div>
</template>
<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import Views from '@/views'
import store from '@/store'
import { Notification, MessageBox } from 'element-ui'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  created() {
    this.getMenuMapping()
  },
  components: {
    CheckWord: Views.CheckWord,
    ErrorStudy: Views.ErrorStudy,
    Home: Views.Home,
    Product: Views.Product,
    Factory: Views.Factory,
    User: Views.User,
    KeyLicence: Views.KeyLicence,
    KeyFactory: Views.KeyFactory
  },
  methods: {
    ...mapActions([     
      'getMenuMapping'
    ]),
    showMenu() {
      store.commit('SET_MENU_TYPE',!store.getters.menuType)
    },
    closePage(e) {
      //console.log(store.getters.pageNames.slice(e.currentTarget.id,1))
      store.commit('DEL_PAGE_NAME',e.currentTarget.id)
    },
    activePage(e) {
      //console.log(e.currentTarget.id)
      store.commit('SET_PAGE_NAME',e.currentTarget.id)
    },
    nextPage(e) {
      const nowIndex = store.getters.pageNames.indexOf(store.getters.nowPageValue)
      if(nowIndex+1>=store.getters.pageNames.length){
        Notification.error({
          title: '已经是最后一个！',
          duration: 2500
        })
      }else{
        store.commit('SET_PAGE_NAME',store.getters.pageNames[nowIndex+1])
      }      
    },
    beforePage(e) {
      const nowIndex = store.getters.pageNames.indexOf(store.getters.nowPageValue)
      if(nowIndex == 0){
        Notification.error({
          title: '已经是第一个！',
          duration: 2500
        })
      }else{
        store.commit('SET_PAGE_NAME',store.getters.pageNames[nowIndex-1])
      }      
    },
    closePageAll() {
      store.commit('DEL_PAGE_ALL')
      this.dialogVisible = false
    }
  }
}

</script>
<style scoped lang="scss">
  #page-table{
    display: flex;
    flex-direction: column;    
    width: 100%;
  }
  #home-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    
    #main-header{
      display: flex;
      flex-direction: row;
      height: 42px;
      width: 100%;
      background: #ffffff;
      border-bottom: 1px solid #000;
      #header-title{
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .other-page{
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          border-style: none;
          height: 100%;
          padding-left:15px;
          padding-right:15px;
          .page-close-icon{
            padding-left:5px;
            padding-right: 2px;
            color: #ffffff;
          }

          .page-close-icon:hover{
            padding-right: 0px;
            font-size: 18px;
          }
        }
        .other-page-active{
          background: #323438;
          color: #ffffff;
        }
      }
      .bakc-next{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #999999;
        width: 39px;
      }
      .bakc-next:HOVER{
          cursor: pointer;
          color: #000000;
      }
      #help-ico{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #999999;
        width: 39px;
      }
    }
    #main-content{      
      display: flex;
      flex-direction: row;
      width:100%;
      height: 100%;
      #menu-on-off{
        // background: #00ff22; 
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 40px;
        height: 100%;
        .showmenu-button:hover {
          cursor: pointer;
        }
      }
      .content-one{
        width: 100%;
        height: 100%;
        //overflow:auto;
        overflow-y: scroll;
      }
    }
    
  }
</style>


// WEBPACK FOOTER //
// src/components/PageTable.vue